angular.module('cimerFrontEndApp').controller('DirectorUserUploadCtrl',[
    '$scope', '$routeParams', '$http', '$location', 'Session', 'Upload', 'ApiUrl', '$timeout', 'authorized',
    function ($scope, $routeParams, $http, $location, Session, Upload, ApiUrl, $timeout, authorized) {

        "use strict";
        // If they're not authorized with director privileges for this grant, route away
        if (!authorized) {
            $location.url('/');
            return;
        }
        $scope.authorized = authorized;
        $scope.forms = {};

        var sessionObject = Session.getSessionObject();
        if (!sessionObject.isAuthenticated) {
            $location.url('/');
            return;
        }
        if (!sessionObject.isDirector &&
            !sessionObject.isAlternate &&
            !sessionObject.isAdmin &&
            !sessionObject.isProjectAdmin) {
            $location.url('/');
            return;
        }
        if (sessionObject.isDirector) {
            //Actual director role
            $scope.IsDirector = true;
        }
        else {
            //Alternate role
            $scope.IsDirector = false;
        }

        if ($routeParams.grantID) {
            var value = parseInt($routeParams.grantID, 10);
            if (!isNaN(value)) {
                $scope.grantID = value;
            } else {
                $location.path('error');
                return;
            }
        } else {
            $location.path('director');
            return;
        }

        Session.userCanAccessGrant($scope.grantID).then(function (authorized) {
            // Redirect them to the director's page if they're not authorized for this grant
            if (!authorized) {
                $location.path('director');
                return;
            }
        });
        
        

        // --- CSV/Text Upload ---
        var _apiUrl = ApiUrl.url('/Upload/');

        $scope.MenteeUploadFileTypes = ['.txt', '.csv'];
        $scope.MenteeUploadFileTypesList = $scope.MenteeUploadFileTypes.join(',');

        $http.get(_apiUrl + 'UserRelationshipOptions')
            .then(function (response) {
                $scope.UserRelationshipOptions = response.data;
            });

        $http.get(_apiUrl + 'UserUploadTypes')
            .then(function (response) {
                $scope.UserUploadOptions = response.data;
            });

        $scope.Upload = {};

        $scope.$watch("Upload.SelectedUpload",
            function (newValue, oldValue) {
                if (newValue && (newValue !== oldValue)) {
                    $scope.Cachekey = null;
                    $scope.Mentees = null;
                }
            });

        var uploadUrls = {
            '1': 'UploadMentees',
            '2': 'UploadMentors',
            '3': 'UploadMenteeMentor'
        };

        $scope.showParserSpinner = false;
        $scope.Mentees = null;

        $scope.UploadFunction = function ($file) {

            $scope.Mentees = null;

            $timeout(function () {
                if ($scope.Mentees == null) {
                    $scope.showParserSpinner = true;
                }               
            }, 500);
           
            Upload.upload({
                url: _apiUrl + uploadUrls[$scope.Upload.SelectedUpload],
                file: $file
            })
            .then(function (response) {
                //Success
                $scope.showParserSpinner = false;
                $scope.Mentees = response.data.Mentees;    
            },
            function (err) {
                $location.path('error');
            });
        };

        $scope.clearUpload = false;

        $scope.CancelUpload = function () {
            $scope.Mentees = null;
            $scope.formSubmitted = false;
            $scope.clearUpload = true;
        };

        $scope.SubmitUpload = function () {
            $scope.formSubmitted = true;

            if (!$scope.forms.uploadForm.$valid) {
                $scope.formSubmitted = false;
                return;
            }

            var data = {
                GrantID: $scope.grantID,
                Mentees: $scope.Mentees
            };

            $http.post(_apiUrl + 'CommitMenteeMentorUpload', data)
                .then(function (response) {
                    //TODO: feedback
                    if (response.data) {
                        //Send them either back to the assign page or the director page based on if we have a survey id
                        /*if (!$scope.surveyID) {
                            $location.url("/director/survey");
                        } else {
                            var url = "/assignSurvey/" + $scope.grantID + "/" + $scope.surveyID;
                            $location.url(url);
                        }*/
                        //this route is now grant based, so route back to director dashboard ??
                        $location.path('director');

                        $scope.clearUpload = true;
                        $scope.Cachekey = null;
                        $scope.Mentees = null;
                    }
                },
                function (err) {
                    $scope.formSubmitted = false;
                    $location.path('error');
                });
        };//end submitUpload

        $scope.GetTypeName = function (typeid) {
            var typeName;
            angular.forEach($scope.UserRelationshipOptions, function (val) {
                if (val.Value == typeid) {
                    typeName = val.Text;
                }
            });
            return angular.isUndefined(typeName) ? "None" : typeName;
        };

        // --- Manual Entry Tab code ---
        $scope.showLinkedMentor = false;
        $scope.success = false;
        $scope.error = false;
        $scope.manualInput = {
            Mentee: {
                LastName: null,
                FirstName: null,
                Email: null,
                RelationshipType: null
            },
            SelectedMentor: null,
            Mentor: {
                LastName: null,
                FirstName: null,
                Email: null
            }
        };

        $scope.existingMentors = [];
        var _grantApiUrl = ApiUrl.url('/Grant/');
        var updateExistingMentors = function() {
            $http.get(_grantApiUrl + "GetMentorsForGrant/" + $scope.grantID)
                .then(function(result) {

                    if (result.data.length > 0) {
                        $scope.existingMentors = result.data;
                    }
                });
        };
        updateExistingMentors();


        $scope.$watch('Upload.SelectedUpload',
            function(newval, oldval) {
                if (newval !== oldval) {
                    $scope.clearManualUserAdd();
                }
            });

        $scope.toggleNewLinkedMentor = function (newUser) {
            if (newUser) {
                $scope.showLinkedMentor = true;
                $scope.manualInput.SelectedMentor = null;
            } else {
                $scope.showLinkedMentor = false;
                $scope.manualInput.Mentor = {
                    LastName: null,
                    FirstName: null,
                    Email: null
                };
            }
        };

        $scope.manualUserAdd = function() {

            var commitUser =
            {
                GrantID: $scope.grantID,
                Mentees: []
            };

            if ($scope.Upload.SelectedUpload === "1") {  //new mentee
                commitUser.Mentees.push({
                    FirstName: $scope.manualInput.Mentee.FirstName,
                    LastName: $scope.manualInput.Mentee.LastName,
                    Email: $scope.manualInput.Mentee.Email,
                    RelationshipType: $scope.manualInput.Mentee.RelationshipType,
                    ExistsAlready: false,
                    Mentor: {
                        FirstName: null,
                        LastName: null,
                        Email: null,
                        ExistsAlready: false
                    }
                });
            }
            else if ($scope.Upload.SelectedUpload === "2") { //new mentor
                commitUser.Mentees.push({
                    FirstName: null,
                    LastName: null,
                    Email: null,
                    ExistsAlready: false,
                    Mentor: {
                        FirstName: $scope.manualInput.Mentor.FirstName,
                        LastName: $scope.manualInput.Mentor.LastName,
                        Email: $scope.manualInput.Mentor.Email,
                        ExistsAlready: false
                    }
                });
            }
            else if ($scope.Upload.SelectedUpload === "3" && !$scope.showLinkedMentor) { //new mentee, existing mentor from dropdown
                commitUser.Mentees.push({
                    FirstName: $scope.manualInput.Mentee.FirstName,
                    LastName: $scope.manualInput.Mentee.LastName,
                    Email: $scope.manualInput.Mentee.Email,
                    RelationshipType: $scope.manualInput.Mentee.RelationshipType,
                    ExistsAlready: false,
                    Mentor: {
                        FirstName: $scope.manualInput.SelectedMentor.FirstName,
                        LastName: $scope.manualInput.SelectedMentor.LastName,
                        Email: $scope.manualInput.SelectedMentor.Email,
                        ExistsAlready: true,
                        UserId: $scope.manualInput.SelectedMentor.UserId
                    }
                });
            }
            else if ($scope.Upload.SelectedUpload === "3" && $scope.showLinkedMentor) { //new mentee and mentor
                commitUser.Mentees.push({
                    FirstName: $scope.manualInput.Mentee.FirstName,
                    LastName: $scope.manualInput.Mentee.LastName,
                    Email: $scope.manualInput.Mentee.Email,
                    RelationshipType: $scope.manualInput.Mentee.RelationshipType,
                    ExistsAlready: false,
                    Mentor: {
                        FirstName: $scope.manualInput.Mentor.FirstName,
                        LastName: $scope.manualInput.Mentor.LastName,
                        Email: $scope.manualInput.Mentor.Email,
                        ExistsAlready: false
                    }
                });
            } else {
                //nothing to do here?
            }

            $http.post(_apiUrl + 'CommitMenteeMentorUpload', commitUser)
                .then(function (response) {
                    if (response.data) {
                        $scope.clearManualUserAdd();
                        $scope.success = true;
                        updateExistingMentors();

                    } else {
                        $scope.clearManualUserAdd();
                        $scope.error = true;
                    }
                },
                function (err) {
                    $location.path('error');
                });


        };

        $scope.clearManualUserAdd = function() {
            $scope.manualInput = {
                Mentee: {
                    LastName: null,
                    FirstName: null,
                    Email: null,
                    RelationshipType: null
                },
                SelectedMentor: null,
                Mentor: {
                    LastName: null,
                    FirstName: null,
                    Email: null
                }
            };
            $scope.success = false;
            $scope.error = false;
        };

    }
]);